<template>
	<div class="cardDetail">
		<ul>
			<li v-for="item in cardDetail.sublst">
				<p class="l">{{item.product.name}}</p>
				<p class="r"><span>{{item.sub.billCount}}</span> 张</p>
			</li>
		</ul>
		<p class="price" style="text-align: right;">实体卡费用 共计 <span> {{cardDetail.cardCount}} </span>张：<span class="colo">￥{{(cardDetail.bill.realAmount - cardDetail.bill.expressAmount)/100}} 元</span></p>
		<div class="price" v-if="cardDetail.addr">
			<p class="l">地址:</p>
			<p class="r"><i class="el-icon-location" style="color: #00ABFA;"></i> {{cardDetail.addr.address}}</p>
		</div>
		<div>
			<p class="r price">运费：<span class="colo">￥{{cardDetail.bill.expressAmount/100}}</span></p>
		</div>
		<div class="price">
			<p class="l w1">备注：</p>
			<p class="l w2">{{cardDetail.bill.remark}}</p>
		</div>
		<div>
			<p class="r price">费用统计：<span class="colo">￥{{cardDetail.bill.realAmount/100}} 元</span></p>
		</div>
		<div>
			<p class="r price">付款方式：<span>银行转账</span></p>
		</div>
		<div>
			<p class="r price">物流状态：<span class="coloR">{{status[cardDetail.bill.expressState]}}</span></p>
		</div>

		<el-button type="primary" class='btn'><router-link style='color: inherit;' to="/commodity/buyList">关闭</router-link></el-button>
	</div>
</template>

<script>
	import { entityDetail } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				cardDetail:{
					bill:{}
				},
				status:['未发','已发','签收'],
			}
		},
		methods: {
			setTime(str) {
				return common.time(str)
			},
			getData() {
				entityDetail({billId:this.$route.query.id})
				.then(res => {
					this.cardDetail=res.data.obj
				})
				.catch(err => {
					console.log(res)
				})
			}

		},
		mounted() {
			this.getData()
			
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3 {
		color: #333;
		font-weight: bold;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	ul,
	li {
		list-style: none;
	}

	ul {
		overflow: hidden;
	}

	ul li {
		overflow: hidden;
		line-height: 40px;
	}

	.l {
		float: left;
	}

	.r {
		float: right;
	}

	p {
		line-height: 40px;
		color: #333;
		font-size: 16px;
	}

	.price {
		font-size: 14px;
		line-height: 40px;
	}

	.colo {
		color: #ff7200;
	}

	.coloR {
		color: #df1717;
	}

	div {
		overflow: hidden;
	}

	.w1 {
		width: 50px;
	}

	.w2 {
		width: 850px;
	}

	.blue {
		margin: 0 auto;
		width: 100px;
		height: 40px;
		display: block;
		background: #00ABFA;
		color: #fff;
		text-align: center;
		line-height: 40px;
		margin-top: 20px;
	}

	.cardDetail {
		margin-top: 20px;
		height: calc(100vh - 160px);
		overflow: auto;
		padding: 0 20px;
		max-width: 900px;
		margin: 0 auto;
	}
	.btn{display: block;margin: 0 auto;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/financial/cardorderDetail.vue